import Vue from 'vue'
import axios from 'axios'
import mainBaseUrl from "@/global-components";

const axiosIns = axios.create({
  baseURL: `${mainBaseUrl}api/`,
  withCredentials: true,
})

// ✅ Automatically attach fresh token before every request
axiosIns.interceptors.request.use(config => {
  const token = localStorage.getItem("accessToken")
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
}, error => {
  return Promise.reject(error)
})

Vue.prototype.$http = axiosIns

export default axiosIns
